import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import IeChecker from 'alt-iechecker'
import NotFound from './utils/NotFound.jsx'
import Landing from './routes/Landing.jsx'
import Services from './routes/Services.jsx'
import About from './routes/About.jsx'
import Contact from './routes/Contact.jsx'
import References from './routes/References.jsx'
import Header from './components/Header.jsx'
import Footer from './containers/Footer.jsx'
import MobileHeaderContainer from './containers/MobileHeaderContainer.jsx'

const Routes = props => (
    <Provider store={props.store}>
        <div>
            <IeChecker />
            <Header />
            <MobileHeaderContainer />
            <Switch>
                <Route
                    exact
                    path="/usluge"
                    component={Services}
                />
                <Route
                    path="/reference"
                    component={References}
                />
                <Route
                    exact
                    path="/onama"
                    component={About}
                />
                <Route
                    path="/kontakt/:id?"
                    component={Contact}
                />
                <Route
                    path="/pocetna"
                    component={Landing}
                />
                <Route
                    exact
                    path="/"
                    component={Landing}
                />
                <Route
                    component={NotFound}
                />
            </Switch>
            <Footer />
        </div>
    </Provider>
)

export default Routes



// WEBPACK FOOTER //
// ./src/scripts/Routes.jsx